import React, { useState } from 'react';
import './App.css';
import Login from './components/Login';
const api_key = "199b7a18b2c0b7acc10e433fa6828ca6"; // Replace this with your actual API key

function App() {
  const [zipCodesList, setZipCodesList] = useState("");
  const [givenZipCode, setGivenZipCode] = useState("");
  const [weatherData, setWeatherData] = useState([]);
  const [user, setUser] = useState(null);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
  };

  const handleLogout = () => {
    setUser(null);
  };

  const fetchDataForZipCodes = async () => {
    try {
      const zipCodes = zipCodesList.split(',').map(zipCode => zipCode.trim());
      const givenZipCodeData = await fetchWeatherData(givenZipCode);
      if (!givenZipCodeData) {
        console.log(`Error getting location data for ${givenZipCode}`);
        return;
      }

      const weatherDataPromises = zipCodes.map(async (zipCode) => {
        if (zipCode === givenZipCode) {
          return {
            city: givenZipCodeData.city,
            zipCode: givenZipCodeData.zipCode,
            dist: 0
          };
        }

        const data = await fetchWeatherData(zipCode);
        if (!data) {
          console.log(`Error getting location data for ${zipCode}`);
          return null;
        }

        const dist = round(getDistanceFromLatLonInMiles(givenZipCodeData.location, data.location), 2);
        return { city: data.city, zipCode, dist };
      });

      const weatherDataResults = await Promise.all(weatherDataPromises);
      setWeatherData(weatherDataResults.filter(Boolean).sort((a, b) => a.dist - b.dist));
    } catch (error) {
      console.error('Error fetching weather data:', error);
    }
  };

  const fetchWeatherData = async (zipCode) => {
    try {
      const url = `https://api.openweathermap.org/data/2.5/weather?zip=${zipCode}&appid=${api_key}`;
      const response = await fetch(url);
      if (response.status === 200) {
        const data = await response.json();
        const city = data.name;
        const location = {
          lat: data.coord.lat,
          lon: data.coord.lon
        };
        return { city, zipCode, location };
      } else {
        return null;
      }
    } catch (error) {
      console.error(`Error fetching weather data for ${zipCode}:`, error);
      return null;
    }
  };

  const round = (value, decimals) => {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
  };

  const handleZipCodesListChange = (event) => {
    setZipCodesList(event.target.value);
  };

  const handleGivenZipCodeChange = (event) => {
    setGivenZipCode(event.target.value);
  };

  const handleGetWeatherData = () => {
    fetchDataForZipCodes();
  };

  // Haversine formula to calculate distance between two latitude and longitude points in miles
  const getDistanceFromLatLonInMiles = (point1, point2) => {
    const R = 3958.8; // Radius of the earth in miles
    const dLat = deg2rad(point2.lat - point1.lat);
    const dLon = deg2rad(point2.lon - point1.lon);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(point1.lat)) * Math.cos(deg2rad(point2.lat)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in miles
    return distance;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  const handleReset = () => {
    setZipCodesList("");
    setGivenZipCode("");
    setWeatherData([]);
  };

  const getLogoForUser = (username) => {
    const firstChar = username.charAt(0).toLowerCase();
    if(firstChar === 'c'){
      return `https://drive.google.com/uc?export=view&id=1_JWm0zvOCUB3vhXX8BKhC1LWB_eCwuMN`;
    }else if (firstChar === 'l'){
      return `https://drive.google.com/uc?export=view&id=1BME4TdRRN0NZTsaZyYqIPD3AM0e8dtCY`;
    }
    
  };

  return (
    <div className="App">

      {user ? (
        // Render the main app here when the user is logged in
        <>
          <img src={getLogoForUser(user.username)} alt="User Logo" />
          <nav className="navbar">
            <div>
              <button onClick={handleLogout}>Logout</button>
            </div>
          </nav>
          <h1>Welcome, {user.name}!</h1>
          <h1>Distance between Zip Codes</h1>
          <div>
          <h3>Origin ZipCode</h3>
          <input type="text" value={givenZipCode} onChange={handleGivenZipCodeChange} placeholder="Enter ZIP code to find results" />
          <p></p>
          <h3>Destination ZipCodes</h3>
          <input type="text" value={zipCodesList} onChange={handleZipCodesListChange} placeholder="Enter ZIP codes separated by commas" />
          <p></p>
          <button onClick={handleGetWeatherData}>Get Distance Data</button>
          <p></p>
          <button onClick={handleReset}>Reset</button>
          </div>
          <h2>Results:</h2>
          <ul>
          {weatherData.map(({ city, zipCode, dist }) => (
            <li key={zipCode}>
              {city} ({zipCode}): {dist} miles {zipCode === givenZipCode && '(Given Zip Code)'}
            </li>
          ))}
          </ul>
        </>
      ) : (
        // Render the login page when the user is not logged in
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
